import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { Modal } from 'antd';
import { type IMapGroup } from '../layers/MapGroup.ts';
import { type IMapLayer } from '../layers/MapLayer.ts';

/**
 * Elimina un gruppo tematico.
 * Se il gruppo ha layer associati, mostra una modale di conferma e
 * sposta i layer nella sezione "Altri" (group: undefined).
 */
export function confirmAndDeleteGroup(
  groupEditor: RelationEditor<IMapGroup>,
  layersEditor: RelationEditor<IMapLayer>,
  groupIndex: number,
) {
  const group = groupEditor.items[groupIndex];
  if (!group) return;

  const layers: IMapLayer[] = layersEditor.getValue() ?? [];
  const affectedCount = layers.filter(
    layer => layer.group === group.name,
  ).length;

  if (affectedCount > 0) {
    Modal.confirm({
      title: 'Elimina gruppo',
      content: `Il gruppo "${group.label || group.name}" è associato a ${affectedCount} ${affectedCount === 1 ? 'livello' : 'livelli'}. Eliminandolo, ${affectedCount === 1 ? 'il livello verrà spostato' : 'i livelli verranno spostati'} nella sezione "Altri".`,
      okText: 'Elimina',
      okType: 'danger',
      cancelText: 'Annulla',
      onOk: () => {
        const currentLayers: IMapLayer[] = layersEditor.getValue() ?? [];
        const updated = currentLayers.map(layer =>
          layer.group === group.name ? { ...layer, group: undefined } : layer,
        );
        layersEditor.replace(updated);
        groupEditor.removeAt(groupIndex);
      },
    });
  } else {
    groupEditor.removeAt(groupIndex);
  }
}
